import useLsaChargeName from '../../hooks/useLsaChargeName'
import { showSnackBar } from '../Snackbar/Snackbar'

const NOT_SAVED = 'The charge name was not saved. Try again.'

const LsaChargeNamePicker = ({ userId }) => {
  const { required, options, pick, choose } = useLsaChargeName(userId)

  if (!required) return null

  const pickName = async (key) => {
    const result = await choose(key)
    if (result?.error) showSnackBar('error', result.payload || NOT_SAVED)
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-text-primary">Charge as:</span>
      <div role="group" aria-label="Charge as" className="inline-flex rounded-lg border border-divider overflow-hidden">
        {options.map((option) => (
          <button
            key={option.key}
            type="button"
            aria-pressed={pick?.key === option.key}
            className={`px-4 py-1.5 text-sm font-medium transition-colors ${pick?.key === option.key ? 'bg-primary-main text-primary-contrast' : 'bg-transparent text-text-secondary hover:text-text-primary'}`}
            onClick={() => pickName(option.key)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default LsaChargeNamePicker
